const faqs = [
  {
    question: '¿Qué es la categoría 4x4?',
    answer: (
      <div className="space-y-2">
        <p>
          La categoría 4x4 es una modalidad de importación que permite traer compras del extranjero
          sin pagar impuestos aduaneros siempre que cumplan con dos condiciones:
        </p>
        <ul className="list-disc list-inside  text-gray-300">
          <li>Peso máximo: 4 kg por paquete</li>
          <li>Valor máximo: $400 por paquete</li>
        </ul>
        <p>
          Es ideal para artículos pequeños o medianos como ropa, accesorios, gadgets,
          cosméticos y más.
        </p>
      </div>
    )
  },
  {
    question: '¿Qué es la Categoría C?',
    answer: (
      <div className="space-y-2">
        <p>
          Es una modalidad de importación para productos más grandes, pesados o de mayor valor.
        </p>
        <p>Incluye artículos como:</p>
        <ul className="list-disc list-inside text-gray-300">
          <li>Repuestos de autos</li>
          <li>Electrodomésticos grandes</li>
          <li>Maquinaria</li>
        </ul>
        <p>
          Estos productos sí pasan por aduana en Ecuador.
        </p>
        <p>Su costo se calcula según:</p>
        <ul className="list-disc list-inside text-gray-300">
          <li>Peso / volumen</li>
          <li>Tipo de producto</li>
          <li>Impuestos aduaneros aplicables</li>
        </ul>
      </div>
    )
  },
  {
    question: '¿Cómo puedo rastrear mi pedido?',
    answer: (
      <div className="space-y-2">
        <p>
          Puedes rastrear tu compra en todo momento desde nuestra sección de Tracking.
        </p>
        <p>
          Solo debes registrarte o iniciar sesión en nuestra página para acceder y conocer
          el estado de tu envío en tiempo real.
        </p>
      </div>
    )
  },
  {
    question: '¿Cuáles son los métodos de pago aceptados?',
    answer: (
      <div className="space-y-2">
        <p>Puedes realizar tu pago mediante:</p>
        <ul className="list-disc list-inside text-gray-300">
          <li>Transferencia bancaria</li>
          <li>PayPhone</li>
        </ul>
        <p>
          Uno de nuestros asesores te proporcionará los datos y el enlace correspondiente
          al momento de confirmar tu compra.
        </p>
      </div>
    )
  },
  {
    question: '¿Con qué servicios cuenta Kifli Courier?',
    answer: (
      <div className="space-y-4">
        <p>
          Ofrecemos dos modalidades de importación para que elijas la que mejor se adapte a tu necesidad:
        </p>

        <div>
          <h4 className="font-semibold text-lime-400 mb-1">Servicio PRO</h4>
          <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
            <li>Categoría 4x4: hasta 4 kg y $400 de valor total</li>
            <li>
              Tiempo de entrega: Contamos con +6 fechas de vuelo al mes,
              actualizadas en nuestra cuenta de Instagram @kifli.ec
            </li>
            <li>Tarifa: $8,55 por libra *Valor final (incluye IVA y Arancel)</li>
            <li>Proceso de importación ágil, priorizado y personalizado</li>
            <li>¡Perfecto para compras urgentes!</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-lime-400 mb-1">Servicio KIFIX</h4>
          <ul className="list-disc list-inside space-y-1 text-sm text-gray-300">
            <li>Categoría 4x4: hasta 4 kg y $400 de valor total</li>
            <li>
              Tiempo de entrega: 7 días laborables
              (una vez que tu compra llegue a nuestra bodega en Miami)
            </li>
            <li>Tarifa: $7,55 por libra *Valor final (incluye IVA y Arancel)</li>
            <li>Pasa por Aduana en Ecuador</li>
            <li>¡Ideal si quieres ahorrar sin apuros!</li>
          </ul>
        </div>
      </div>
    )
  },
  {
    question: '¿Puedo traer compras fuera de la categoría 4x4 con Kifli?',
    answer: (
      <div className="space-y-2">
        <p>
          ¡Claro que sí! También importamos productos que superan los límites de la categoría 4x4,
          como electrónicos de mayor valor.
        </p>
        <ul className="list-disc list-inside text-gray-300">
          <li>Celulares</li>
          <li>iPads</li>
          <li>Laptops</li>
          <li>Relojes</li>
          <li>Perfumes</li>
        </ul>
        <p>
          Incluso podemos ayudarte a traer repuestos para autos según sus características
          y regulaciones específicas.
        </p>
        <p>
          Estos productos se manejan bajo nuestra tabla de precios fijos por producto.
        </p>
        <p className="font-semibold">
          Nota importante:
        </p>
        <p>
          Si el producto supera las dimensiones o peso permitidos para importarlo en equipaje,
          se cotiza bajo la Categoría C.
        </p>
      </div>
    )
  },
  {
    question: '¿Puedo devolver un producto?',
    answer: (
      <div className="space-y-2">
        <p>
          Kifli Courier no se responsabiliza por el estado en que las tiendas de EE. UU.
          entregan los paquetes en nuestra bodega.
        </p>
        <p>
          Si detectamos alguna novedad al recibirlo, te notificaremos de inmediato
          desde nuestra bodega en Miami.
        </p>
        <p>
          Una vez que el paquete es entregado en Ecuador, solicitamos que lo revises
          al momento de la entrega.
        </p>
        <p className="font-semibold">
          Pasado ese momento, no se aceptan reclamos relacionados con el contenido
          o estado del paquete.
        </p>
      </div>
    )
  }
];

export default faqs;

